'use strict';

function renderTasksDone ($marketingChecklist, tasksDone) {
  $marketingChecklist
    .find('[data-tasks-category=done] .badge')
    .text(tasksDone.length);
}

module.exports = renderTasksDone;
